'use strict';

const Backbone = require('backbone/backbone');

require('./IndexAlbums.less');

const YoutubePlayer = require('youtube-player');
const VimeoPlayer = require('@vimeo/player').default;
require('jquery-touchswipe');


module.exports = Backbone.View.extend({

    el: '.IndexAlbums',

    events: {
        'click .IndexAlbums-thumb': 'onThumbClick',
        'click .IndexAlbums-cover-prev': 'onThumbClick',
        'click .IndexAlbums-cover-next': 'onThumbClick',
        'click .IndexAlbums-cover-prev-mobile': 'onThumbClick',
        'click .IndexAlbums-cover-next-mobile': 'onThumbClick'
    },

    initialize: function () {
        this.initializedItems = {};

        var self = this;

        if (!app.settings.isPhone) {
            this.$('.IndexAlbums-thumbs').onCustom('screen-position', function (e, data) {
                if (data.screenPosition > 0) {
                    self.$('.IndexAlbums-thumb').each(function (index, item) {
                        $(item).css({
                            transition: '0.2s opacity linear ' + Math.round(Math.random() * 700) + 'ms',
                            opacity: 1
                        });

                        var img = $(item).find('img')[0];
                        img.setAttribute('src', img.getAttribute('data-src'));
                    });
                    data.$el.offCustom('screen-position');
                }
            });
        }

        this.$el.onCustom('screen-position', function (e, data) {
            if (data.screenPosition > 0) {
                data.$el.offCustom('screen-position');
                self.onItemShow(1);
            }
        });


        if (app.settings.isPhone) {
            app.utils.blockScrollOnSwipe(this.$('.IndexAlbums-cover-container')[0]);

            this.albumsCount = this.$('.IndexAlbums-cover').length - 1;

            /*eslint-disable */
            this.$('.IndexAlbums-cover-container').swipe({
                allowPageScroll: 'vertical',
                threshold: 50,
                swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                    var dir = 0;
                    if (direction === 'left') {
                        dir = +1;
                    }
                    if (direction === 'right') {
                        dir = -1;
                    }
                    if (dir) {
                        var id = this.currentId + dir;
                        console.log(this.albumsCount);
                        if (id < 1) id = this.albumsCount;
                        if (id > this.albumsCount) id = 1;
                        this.onItemShow(id);
                    }
                }.bind(this)
            });
            /*eslint-enable */
        }
    },

    showItem: function (id, cb) {
        if (id === undefined) {
            return;
        }

        var delay = 30;

        if (!this.initializedItems[id]) {
            this.initializedItems[id] = {};

            var $embed = this.$('.IndexAlbums-info[data-id="' + id + '"] .IndexAlbums-info-embed');

            if ($embed.length) {
                var youtubeId = $embed.attr('data-youtube');
                var vimeoId = $embed.attr('data-vimeo');

                if (youtubeId) {
                    this.initializedItems[id].ytPlayer = new YoutubePlayer($embed.find('div')[0], {
                        videoId: $embed.attr('data-youtube'),
                        playerVars: {
                            'autoplay': 0,
                            'controls': 1,
                            'autohide': 1,
                            'wmode': 'opaque'
                        }
                    });
                }

                if (vimeoId) {
                    this.initializedItems[id].vmPlayer = new VimeoPlayer($embed.find('div')[0], {
                        id: vimeoId,
                        width: 640,
                        loop: true
                    });
                }
            }

            var $cover = this.$('.IndexAlbums-cover[data-id="' + id + '"]');

            $cover.find('source').each(function () {
                var srcset = this.getAttribute('data-srcset');
                var sizes = this.getAttribute('data-sizes');
                srcset && this.setAttribute('srcset', srcset);
                sizes && this.setAttribute('sizes', sizes);
            });

            $cover.find('img').each(function () {
                var src = this.getAttribute('data-src');
                src && this.setAttribute('src', src);
            });

            delay = 100;
        }

        clearTimeout(this.initializedItems[id].showTimeout);
        clearTimeout(this.initializedItems[id].hideTimeout);

        this.$('.IndexAlbums-cover[data-id="' + id + '"]').css('display', 'inline-block');
        this.$('.IndexAlbums-info[data-id="' + id + '"]').css('display', 'inline-block');

        this.initializedItems[id].showTimeout = setTimeout(function () {
            this.$('.IndexAlbums-cover[data-id="' + id + '"]').addClass('visible');
            this.$('.IndexAlbums-info[data-id="' + id + '"]').addClass('visible');
            cb();
        }.bind(this), delay);
    },


    hideItem: function (id) {
        if (id === undefined) {
            return;
        }

        this.$('.IndexAlbums-cover[data-id="' + id + '"]').removeClass('visible');
        this.$('.IndexAlbums-info[data-id="' + id + '"]').removeClass('visible');

        clearTimeout(this.initializedItems[id].showTimeout);
        clearTimeout(this.initializedItems[id].hideTimeout);

        this.initializedItems[id].hideTimeout = setTimeout(function () {
            if (this.initializedItems[id].ytPlayer) {
                this.initializedItems[id].ytPlayer.pauseVideo();
            }

            if (this.initializedItems[id].vmPlayer) {
                this.initializedItems[id].vmPlayer.pause();
            }

            this.$('.IndexAlbums-cover[data-id="' + id + '"]').css('display', '');
            this.$('.IndexAlbums-info[data-id="' + id + '"]').css('display', '');

            app.vent.trigger('page-height-changed');
        }.bind(this), 350);
    },


    onThumbClick: function (e) {
        var id = $(e.currentTarget).attr('data-id') - 0;

        this.onItemShow(id);

        this.$('.IndexAlbums-thumbs-scroll-barrier')[0].scrollIntoView({
            behavior: 'smooth'
        });
    },


    onItemShow: function (id) {
        this.currentId = id;

        if (id === this.prevShownId) {
            return;
        }

        var prevShownId = this.prevShownId;

        this.showItem(id, function () {
            this.hideItem(prevShownId);
        }.bind(this));

        //first time
        if (!prevShownId) {
            app.vent.trigger('page-height-changed');
        }

        this.prevShownId = id;
    }
});
